import React from 'react';
import { Ticket } from '../../common-types/Ticket.type';
import { Site } from '../../common-types/Site.type';
import { Campaign } from '../../common-types/Campaign.type';
export type InformationType = {
  ticket?: Ticket,
  site?: Site,
  campaign?: Campaign,
}
type InformationContextType = {
  information: InformationType;
  setInformation: (info: InformationType) => void;
};

export const InformationContext = React.createContext<InformationContextType>({
  information: {},
  setInformation: () => undefined as void,
});
